<template>
  <div
    v-if="loading"
    class="clearfix"
  >
    <b-spinner
      class="float-right"
      label="Floated Right"
    />
  </div>
  <div v-else>
    <b-row>
      <b-col
        lg="12"
        md="12"
      >
        <app-collapse type="margin">
          <app-collapse-item
            v-if="verificarPermissao('ROLE_OUTRO_CONSULTAR')"
            title="Informações Pessoais"
          >
            <FormPersonalInfoVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_HISTORICO_TIPO_REGISTRO_CONSULTAR')"
            title="Tipo de Registro"
          >
            <FormPersonalRegistryTypeVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_HISTORICO_SITUACAO_REGISTRO_CONSULTAR')"
            title="Situação"
          >
            <FormPersonalNotesVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_HISTORICO_FAIXA_CONTRIBUICAO_REGISTRO_CONSULTAR')"
            title="Faixa de Contribuição"
          >
            <FormOtherFaixaContribuicaoVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_DOCUMENTO_CONSULTAR')"
            title="Documentações"
          >
            <FormPersonalDocumentsVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_ENDERECO_CONSULTAR')"
            title="Endereços"
          >
            <FormPersonalEnderecosVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_FONE_CONSULTAR')"
            title="Fones"
          >
            <FormOtherFonesVue />
          </app-collapse-item>

          <app-collapse-item title="Assinatura">
            <FormDigitalSignatureVue
              store-name="othersAdministrativeModule"
              object-name="fullOther"
              action-name="editOtherDadosPessoais"
              prepare-action-name="prepareToEditFullOther"
            />
          </app-collapse-item>
        </app-collapse>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BSpinner } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { verificarPermissao } from '@/auth/utils'
import FormPersonalInfoVue from './FormOtherPersonalInfo.vue'
import FormPersonalDocumentsVue from './FormOtherDocuments.vue'
import FormPersonalNotesVue from './FormOtherSituation.vue'
import FormPersonalEnderecosVue from './FormOtherEnderecos.vue'
import FormOtherFonesVue from './FormOtherFone.vue'
import FormOtherTipoRegistroVue from './FormOtherTipoRegistro.vue'
import FormOtherFaixaContribuicaoVue from './FormOthersFaixaContribuicao.vue'
import FormDigitalSignatureVue from '../../../associantes/forms/personal/FormDigitalSignature.vue'

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    FormPersonalInfoVue,
    FormPersonalDocumentsVue,
    FormPersonalNotesVue,
    FormPersonalEnderecosVue,
    FormOtherFonesVue,
    FormPersonalRegistryTypeVue: FormOtherTipoRegistroVue,
    FormOtherFaixaContribuicaoVue,
    FormDigitalSignatureVue,
    BRow,
    BCol,
    BSpinner,
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      verificarPermissao,
      collapseType: 'default',
    }
  },
}
</script>
